import script from "./1_Consignee.vue?vue&type=script&setup=true&lang=ts"
export * from "./1_Consignee.vue?vue&type=script&setup=true&lang=ts"

import "./1_Consignee.vue?vue&type=style&index=0&id=1e701c5d&lang=css"

const __exports__ = script;

export default __exports__